import { darken, lighten } from "@mui/material";

export const getShades = (mainColor: string) => {
	return {
		main: mainColor,
		50: lighten(mainColor, 0.95),
		100: lighten(mainColor, 0.9),
		200: lighten(mainColor, 0.8),
		300: lighten(mainColor, 0.7),
		400: lighten(mainColor, 0.6),
		500: lighten(mainColor, 0.5),
		600: darken(mainColor, 0.1),
		700: darken(mainColor, 0.2),
		800: darken(mainColor, 0.3),
		900: darken(mainColor, 0.4),
	};
};

const primaryMain = "#823BEB";
const secondaryMain = "#ED00BB";
const warningMain = "#FF8E00";
const successMain = "#00B84D";
const dangerMain = "#F34236";

export const primaryColors = getShades(primaryMain);
export const secondaryColors = getShades(secondaryMain);
export const warningColors = getShades(warningMain);
export const successColors = getShades(successMain);
export const dangerColors = getShades(dangerMain);
export const commonColors = {
	black: "#000",
	white: "#FFF",
};
export const greyColors = {
	"100": "#FAFAFA",
	"200": "#DDD",
	"300": "#BBB",
	"400": "#AAA",
	"500": "#777",
	"600": "#444",
	"700": "#222",
};

export const legacyColors = {
	primary: {
		main: "#2B4673",
		"100": "#F4F6F8",
		"200": "#CAD1DC",
		"300": "#95A2B9",
		"400": "#1A2A45",
		"500": "#111C2E",
		contrastText: commonColors.white,
	},
	secondary: {
		main: "#EE3F5C",
		"100": "#FEF5F7",
		"200": "#FBCFD6",
		"300": "#F79FAE",
		"400": "#8F2637",
		"500": "#5F1925",
		contrastText: commonColors.white,
	},
	warning: {
		main: "#FBAD18",
		"100": "#FFFBF4",
		"200": "#FEEAC5",
		"300": "#FDD68B",
		"400": "#97680E",
		"500": "#64450A",
		A100: "#F9B395",
		contrastText: commonColors.white,
	},
	success: {
		main: "#4CA735",
		"100": "#F6FBF5",
		"200": "#D2E9CC",
		"300": "#B0CDB1",
		"400": "#A5D39A",
		"500": "#2E6420",
		"600": "#1E4315",
		contrastText: commonColors.white,
	},
};
